import {
  GET_TOPTOURS_ERR,
  GET_TOPTOURS_REQ,
  GET_TOPTOURS_RES,
} from '../constants';

const initState = {
  toptours: [],
  toptours_loaded: false,
  errors: [],
};

const reducer = (state = initState, action) => {
  switch (action.type) {
    case GET_TOPTOURS_REQ:
      return {
        ...state,
        toptours_loaded: false,
      };

    case GET_TOPTOURS_RES:
      return {
        ...state,
        toptours_loaded: true,
        toptours: action.payload,
      };

    case GET_TOPTOURS_ERR:
      return {
        ...state,
        //    ##### 23-09-01 Komarov
        errors: (state.errors && [...state.errors, action.error]) || [
          action.error,
        ],
      };

    default:
      return state;
  }
};

export default reducer;
